import React, { useEffect, useState } from "react";

// Style
import "./Cookie.scss";

// Helpers
import Cookies from "js-cookie";
import CookieConsent from "react-cookie-consent";

// Constants
import { amplitudeInstance, events, REACT_APP_AMPLITUDE_KEY } from "constans/cookie";

// components
import Img from "components/Img";

// Navigation
import { Link } from "react-router-dom";

// Styles
const buttonStyle = {
  minWidth: "93px",
  minHeight: "26px",
  border: "unset",
  cursor: "pointer",
  padding: "0.8rem 2rem",
  background: "#FFBE7F",
  borderRadius: "100px",
  color: "#46766F",
  fontSize: "1.2rem",
  fontStyle: "normal",
  lineHeight: 1.4,
  fontFamily: "Poppins",
  letterSpacing: "-0.02em"
};
const mainStyle = {
  left: "50%",
  bottom: "0px",
  width: "1054px",
  borderRadius: "12px",
  background: "#FEFEFE",
  transform: "translate(-50%, -10px)",
  boxShadow: "1px 1px 1px rgba(6, 6, 6, 0.1)"
};

amplitudeInstance.init(REACT_APP_AMPLITUDE_KEY, undefined, {
  includeUtm: true,
  includeGclid: true,
  includeReferrer: true
});

const CookiesView = () => {
  const zone: string = window.location.hostname || "";

  const [isConsentAccepted, setIsConsentAccepted] = useState(false);

  useEffect(() => {
    if (isConsentAccepted && (
      zone === "ebc.enamine.net")
    ) {
      amplitudeInstance.logEvent(events.cookie_notice_popup);
    }
  }, [isConsentAccepted, zone]);

  const handleAccept = () => {
    Cookies.set("cookieName", "accepted", { expires: 365 });
    setIsConsentAccepted(true);
    amplitudeInstance.logEvent(events.cookie_notice_accept);
  };

  return <CookieConsent
      expires={365}
      buttonText="I Agree"
      onAccept={handleAccept}
      style={{ ...mainStyle }}
      buttonStyle={buttonStyle}
    >
    <div className="cookie-content">
        <div className="flex flex-ai-start">
          <Img alt="Cookie" name="cookie" withoutLoader className="cookie-content__img" />

          <div className="ml15">
            <h4 className="cookie-content__title">This site uses cookies.</h4>
            <p className="cookie-content__text">
              Some of these cookies are essential, while others help us to improve your experience by providing insights
              into how the site is being used. For more information see our <Link
              to="/privacy-policy">Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </CookieConsent>;
};

export default CookiesView;
